import React from 'react';
import { Card, Button, Badge, ListGroup } from 'react-bootstrap';

const ActiveFilters = ({ activeFilters, availableFilters, onRemoveFilter, onClearAll }) => {
  const getFilterDisplayValue = (filterId, value) => {
    const filter = findFilterById(filterId);
    if (!filter) return String(value);

    switch (filter.filter_type) {
      case 'range':
        if (value && typeof value === 'object' && value.min !== undefined && value.max !== undefined) {
          return `${value.min} - ${value.max}`;
        }
        return String(value);
      
      case 'date':
        return value ? new Date(value).toLocaleDateString() : '';
      
      default:
        return String(value);
    }
  };

  const findFilterById = (filterId) => {
    if (!availableFilters || !availableFilters.categories) return null;
    
    for (const category of Object.values(availableFilters.categories)) {
      const found = category.find(f => f.id === filterId);
      if (found) return found;
    }
    return null;
  };

  const activeCount = Object.keys(activeFilters).length;

  return (
    <Card className="sticky-top" style={{ top: '1rem' }}>
      <Card.Header className="d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Active Filters</h5>
        <Badge bg="primary" pill>{activeCount}</Badge>
      </Card.Header>
      
      <Card.Body>
        {activeCount === 0 ? (
          <p className="text-muted text-center py-3">No filters applied yet</p>
        ) : (
          <>
            <ListGroup variant="flush" className="mb-3">
              {Object.entries(activeFilters).map(([filterId, value]) => {
                const filter = findFilterById(filterId);
                if (!filter) return null;

                return (
                  <ListGroup.Item key={filterId} className="d-flex justify-content-between align-items-start px-0">
                    <div className="flex-grow-1">
                      <div className="fw-medium">{filter.name}</div>
                      <small className="text-muted">
                        {getFilterDisplayValue(filterId, value)}
                      </small>
                    </div>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => onRemoveFilter(filterId)}
                      className="ms-2"
                    >
                      ×
                    </Button>
                  </ListGroup.Item>
                );
              })}
            </ListGroup>
            
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={onClearAll}
              className="w-100 mb-3"
            >
              Clear All Filters
            </Button>
          </>
        )}
        
        {/* Estimated Results */}
        {/* <div className="bg-light p-3 rounded">
          <h6 className="mb-2">Estimated Results</h6>
          <div className="h4 text-primary mb-0">{estimatedCount?.toLocaleString() || '---'}</div>
          <small className="text-muted">Total matching leads</small>
        </div> */}
      </Card.Body>
    </Card>
  );
};

export default ActiveFilters;